<section class="custom-section">
  <section
    *ngIf="isAzzurroHubOffline === true"
    class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
    <customer-icon-text [text]="labels.offlineDevice">
    </customer-icon-text>
    <customer-title-content [content]="labels.offlineDeviceDescription">
    </customer-title-content>
    <customer-simple-button
      [label]="labels.checkAgain"
      [action]="checkAzzurroHubConnection">
    </customer-simple-button>
  </section>
  <div class="fx-row fx-wrap fx-gap-3">
    <div class="configuration-section">
      <customer-title-content [title]="labels.plantName">
      </customer-title-content>
      <customer-simple-input
        class="mb-6"
        data-testid="settings-plant-name"
        [placeholder]="labels.plantNamePlaceholder"
        [input]="plantConfiguration?.controls?.plantName">
      </customer-simple-input>
      <customer-title-content
        [title]="labels.locationTitle"
        [content]="labels.locationDescription">
      </customer-title-content>
      <customer-maps-form
        [coordinates]="coordinates"
        [labels]="{
          'inputPlaceholder': labels.mapCoordinationPlaceholder
        }"
        [editable]="isControlCoordinatesEnabled"
        (position)="plantConfiguration && handleLocationControlChange($event, plantConfiguration, 'coordinates')">
      </customer-maps-form>
      <ng-container *ngIf="showMeterInversionInput">
        <customer-title-content
          [title]="labels.meterSignTitle"
          [content]="labels.meterSignDescription">
        </customer-title-content>
        <mat-form-field
          data-testid="settings-meter-inversion"
          subscriptSizing="dynamic"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-select
            *ngIf="virtualConfiguration.controls.meterInversion"
            [placeholder]="labels.meterSignPlaceholder"
            [formControl]="virtualConfiguration.controls.meterInversion">
            <mat-option
              *ngFor="let inversion of meterSignOptions"
              class="tw-tabular-nums tw-font-normal tw-text-base"
              [value]="inversion.value">
              {{ inversion.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>

    <div
      *ngIf="canApplyConnextChanges"
      class="configuration-section">
      <customer-title-content
        [title]="labels.contractPowerTitle"
        [content]="labels.contractPowerDescription">
      </customer-title-content>
      <customer-simple-input
        class="mb-6"
        [placeholder]="labels.contractPowerPlaceholder"
        [input]="connextConfiguration?.controls?.plantPower">
      </customer-simple-input>
      <customer-title-content
        [title]="labels.plantTypeTitle"
        [content]="labels.plantTypeDescription">
      </customer-title-content>
      <customer-title-content
        *ngIf="isPlantTypeDisabled"
        class="content-warn"
        [content]="labels.plantTypeDisabled">
      </customer-title-content>
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-mat-form-field w-full custom-border-bottom">
        <mat-select
          *ngIf="connextConfiguration"
          [placeholder]="labels.phaseSelectPlaceholder"
          [formControl]="connextConfiguration.controls.plantType">
          <mat-option
            *ngFor="let phase of [
              labels.singlePhase,
              labels.threePhase
            ]; let index = index"
            class="tw-tabular-nums tw-font-normal tw-text-base"
            [value]="index">
            {{ phase }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="connextMeterConfig">
        <customer-title-content
          [title]="labels.meterSignTitle"
          [content]="labels.meterSignDescription">
        </customer-title-content>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-select
            [placeholder]="labels.meterSignPlaceholder"
            [formControl]="connextMeterConfig.controls.sign">
            <mat-option
              *ngFor="let direction of [
                labels.meterSignInverted,
                labels.meterSignNormal
              ]; let index = index"
              class="tw-tabular-nums tw-font-normal tw-text-base"
              [value]="index === 0 ? -1 : 1">
              {{ direction }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="connextSensorConfig">
        <customer-title-content
          [title]="labels.sensorSignTitle"
          [content]="labels.sensorSignDescription">
        </customer-title-content>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-select
            [placeholder]="labels.meterSignPlaceholder"
            [formControl]="connextSensorConfig.controls.sign">
            <mat-option
              *ngFor="let direction of [
                labels.meterSignInverted,
                labels.meterSignNormal
              ]; let index = index"
              class="tw-tabular-nums tw-font-normal tw-text-base"
              [value]="index === 0 ? -1 : 1">
              {{ direction }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="connextExternalConfig">
        <customer-title-content
          [title]="labels.externalPower"
          [content]="labels.externalPowerDescription">
        </customer-title-content>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-select
            [placeholder]="labels.externalPowerSelectionPlaceholder"
            [formControl]="connextExternalConfig.controls.consider">
            <mat-option
              *ngFor="let option of [
                labels.externalPowerNotConsider,
                labels.externalPowerConsider
              ]; let index = index"
              class="tw-tabular-nums tw-font-normal tw-text-base"
              [value]="index">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>

    <div
      *ngIf="canApplyAzzurroHubChanges"
      class="configuration-section">
      <customer-title-content
        [title]="labels.contractPowerTitle"
        [content]="labels.contractPowerDescription">
      </customer-title-content>
      <customer-simple-input
        class="mb-6"
        [placeholder]="labels.contractPowerPlaceholder"
        [input]="azzurroHubConfiguration?.controls?.contractualPower">
      </customer-simple-input>
      <customer-title-content
        [title]="labels.plantTypeTitle"
        [content]="labels.plantTypeDescription">
      </customer-title-content>
      <customer-title-content
        *ngIf="isAzzurroHubPlantTypeDisabled"
        class="content-warn"
        [content]="labels.plantTypeDisabled">
      </customer-title-content>
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-mat-form-field w-full custom-border-bottom">
        <mat-select
          *ngIf="azzurroHubConfiguration"
          data-testid="plant-type-select"
          [placeholder]="labels.phaseSelectPlaceholder"
          [formControl]="azzurroHubConfiguration.controls.plantType">
          <mat-option
            *ngFor="let phase of [
              labels.singlePhase,
              labels.threePhase
            ]; let index = index"
            class="tw-tabular-nums tw-font-normal tw-text-base"
            [value]="index">
            {{ phase }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <customer-title-content
        [title]="labels.monitoringModeTitle"
        [content]="labels.monitoringModeDescription">
      </customer-title-content>
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-mat-form-field w-full custom-border-bottom">
        <mat-select
          *ngIf="azzurroHubConfiguration"
          data-testid="monitoring-mode-select"
          [placeholder]="labels.monitoringModePlaceholder"
          [formControl]="azzurroHubConfiguration.controls.monitoringMode">
          <mat-option
            *ngFor="let mode of monitoringModeOptions"
            class="tw-tabular-nums tw-font-normal tw-text-base"
            [value]="mode.value">
            {{ mode.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Note: Possibili estensioni future per intSensorInversion, etc. -->
    </div>
  </div>
</section>

<section
  *ngIf="isApplyConnextChangesEnabled"
  class="custom-section mt-3">
  <ng-container *ngIf="!isVerifiedMode">
    <customer-icon-text [text]="labels.plantCreationTitle">
    </customer-icon-text>
    <customer-title-content [content]="labels.plantCreationConnextDisclaimer">
    </customer-title-content>
  </ng-container>
  <customer-simple-button
    [label]="labels.plantCreationConnextApply"
    [action]="configConnext">
  </customer-simple-button>
</section>

<section
  *ngIf="isApplyAzzurroHubChangesEnabled"
  class="custom-section mt-3">
  <ng-container *ngIf="!isVerifiedMode">
    <customer-icon-text [text]="labels.plantCreationTitle">
    </customer-icon-text>
    <customer-title-content [content]="'By applying the changes, the Azzurro Hub configuration will be updated with the plant settings. Remember that for proper setup, you will need to configure the devices connected to your Azzurro Hub.'">
    </customer-title-content>
  </ng-container>
  <customer-simple-button
    [label]="labels.plantCreationConnextApply"
    [action]="configAzzurroHub">
  </customer-simple-button>
</section>
